import { notifications } from "@mantine/notifications";

class NotificationServiceClass {
  showNotification(params: {
    title: string;
    message?: string;
    autoClose?: number | false;
    type?: "error" | "success" | "info" | "warning";
  }) {
    const typeToColor = {
      error: "red",
      success: "green",
      info: "blue",
      warning: "yellow",
    };

    console.log("showNotification", params);
    notifications.show({
      position: "top-center",
      autoClose: params.autoClose === false ? false : params.autoClose || 4000,
      title: params.title,
      message: params.message,
      color: typeToColor[params.type || "info"],
    });
  }
}

export const Notifications = new NotificationServiceClass();
